/* global angular, document */
/* eslint-disable complexity, max-statements */
'use strict';

import log from './logger';
import {escapeSelector} from './utils';

/**
 * Bootstrap all fragments (must be the same type) together.
 * @param fragments list of fragments to bootstrap
 * @param type fragments type
 */
export function bootstrapFragments(fragments, type) {
    // exclude fragments with js files in error (e.g. 404, http timeout)
    const fragmentsToBootstrap = (fragments || []).filter((fragment) => !fragment.error);

    if (fragmentsToBootstrap.length === 0) {
        return;
    }

    log.debug(`bootstrapFragments(): [${type}]`);

    fragmentsToBootstrap.forEach(bootstrapHTML);

    if (type === 'angularjs') {
        bootstrapAngularJS(fragmentsToBootstrap);
    } else if (type === 'static') {
        // no bootstrap to do
    } else {
        log.debug(`bootstrapFragments(): unknown fragment type [${type}]`);
    }
}

/**
 * Bootstrap fragment based on type
 * @param fragment fragment to bootstrap
 */
export function bootstrapFragment(fragment) {
    if (fragment.error) {
        return;
    }
    log.debug(`bootstrapFragment(): ${fragment.name} ${fragment.version || ''} [${fragment.type}]`);

    bootstrapHTML(fragment);

    if (fragment.type === 'angularjs') {
        bootstrapAngularJS([fragment]);
    } else if (fragment.type === 'static') {
        // no bootstrap to do
    } else {
        log.debug(`bootstrapFragment(): unknown fragment type [${fragment.type}]`);
    }
}

function bootstrapAngularJS(fragments) {
    if (typeof angular !== 'undefined') {
        if (document.querySelector('[ng-app]')) {
            log.warn('bootstrapAngularJS(): [ng-app] needs to be removed from DOM');
        }

        try {
            const modules = fragments.map((fragment) => fragment.module || fragment.name.replace('angular-', ''));
            const element = modules.length === 1 ? document.querySelector(`[v-few-frg-loader=${escapeSelector(modules[0])}]`) : null;

            log.debug(`bootstrapAngularJS(): ${modules}`);
            angular.bootstrap(element ? element : document, modules);
        } catch (e) {
            log.error('bootstrapAngularJS(): bootstrap error', e);
        }
    } else {
        log.debug('bootstrapAngularJS(): angular is not loaded');
    }
}

/**
 * HTML is inserted in the DOM before bootstrapping, but shown only after css/js are loaded
 * @param fragment fragment to bootstrap
 */
function bootstrapHTML(fragment) {
    if (fragment.files) {
        fragment.files.forEach((file) => {
            if (file.type !== 'html') {
                return;
            }
            const elem = document.querySelector(`[v-few-frg-loader=${escapeSelector(file.zone)}]`);

            if (elem) {
                elem.nextSibling.style.display = elem.style.display;
                elem.parentNode.removeChild(elem);
            }
        });
    }
}
